import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription, filter } from "rxjs";
import { AppState } from "src/app/store/app.reducer";
import * as DeviceVctActions from 'src/app/store/device-vct/device-vct.actions';
import { StandardPageLayout, StandardNewValidator } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { selectDeviceVctFeatureEdited, selectDeviceVctFeatureEditing, selectDeviceVctModuleEdited, selectDeviceVctModuleEditing } from "src/app/store/device-vct/device-vct.selector";

@Component({
	templateUrl: './edit-device-vct.dialog.component.html',
})

export class EditDeviceVctDialogComponent implements OnInit, OnDestroy {
	editDeviceForm: FormGroup;

	featureId: number;
	moduleId: number;
	name: string;

	deviceVctModuleEditing$: Observable<boolean | undefined>;
	deviceVctModuleEdited$: Observable<boolean | undefined>;
	deviceVctModuleEditedSub: Subscription;
	deviceVctFeatureEditing$: Observable<boolean | undefined>;
	deviceVctFeatureEdited$: Observable<boolean | undefined>;
	deviceVctFeatureEditedSub: Subscription;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private dialogRef: DynamicDialogRef,
		public config: DynamicDialogConfig
	) {

		if (config.data !== undefined && this.config.data.featureId !== undefined) {
			this.featureId = this.config.data.featureId;
		} else {
			this.featureId = undefined;
		}
		if (config.data !== undefined && this.config.data.moduleId !== undefined) {
			this.moduleId = this.config.data.moduleId;
		} else {
			this.moduleId = undefined;
		}
		if (config.data !== undefined && this.config.data.name !== undefined) {
			this.name = this.config.data.name;
		} else {
			this.name = '';
		}
		this.initSelectors();
	}

	initSelectors(): void {
		this.deviceVctModuleEditing$ = this.store.select(selectDeviceVctModuleEditing);
		this.deviceVctModuleEdited$ = this.store.select(selectDeviceVctModuleEdited);
		this.deviceVctFeatureEditing$ = this.store.select(selectDeviceVctFeatureEditing);
		this.deviceVctFeatureEdited$ = this.store.select(selectDeviceVctFeatureEdited);
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.buildForm();
		this.onResize();

		StandardNewValidator.setFirstCompile(true);
	}

	ngOnDestroy(): void {
		this.deviceVctModuleEditedSub?.unsubscribe();
		this.deviceVctFeatureEditedSub?.unsubscribe();
	}

	buildForm(): void {
		this.editDeviceForm = new FormGroup({
			'name': new FormControl(this.name, Validators.required),
		});
	}

	subscribeAll(): void {
		this.deviceVctModuleEditedSub = this.deviceVctModuleEdited$
			.pipe(filter(result => !!result))
			.subscribe(() => this.dialogRef.close('success')
			);
		this.deviceVctFeatureEditedSub = this.deviceVctFeatureEdited$
			.pipe(filter(result => !!result))
			.subscribe(() => this.dialogRef.close('success')
			);
	}

	get f(): any {
		return this.editDeviceForm.controls;
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.editDeviceForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.editDeviceForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		if (this.moduleId !== undefined) {
			this.store.dispatch(DeviceVctActions.editVctModuleName({ moduleId: this.moduleId, aliasName: this.f.name.value }));
		} else if (this.featureId !== undefined) {
			this.store.dispatch(DeviceVctActions.editVctFeatureName({ featureId: this.featureId, aliasName: this.f.name.value }));
		}
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	newShowErrors(type: EditDeviceVctDialogComponent['f'], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: EditDeviceVctDialogComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}
}